/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./selectSourceType.vue?vue&type=template&id=1a97c7e4&scoped=true&"
import script from "./selectSourceType.vue?vue&type=script&lang=js&"
export * from "./selectSourceType.vue?vue&type=script&lang=js&"
import style0 from "./selectSourceType.vue?vue&type=style&index=0&id=1a97c7e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a97c7e4",
  null
  
)

export default component.exports